import { Component, OnInit } from "@angular/core";
import { RawUser, User } from "../../../domain/user";
import { UserRepository } from "../../../domain/user-repository";
import { TenantRepository } from "../../../domain/tenant-repository";
import { Tenant } from "../../../domain/tenant";
import { Router } from "@angular/router";

@Component({
  selector: "users-list",
  templateUrl: "./users-list.component.html",
  styleUrls: ["./users-list.component.scss"],
})
export class UsersListComponent implements OnInit {
  tenantsByIdsDictionary: { [id: string]: Tenant } = {};

  showPreloader = true;
  currentUser: User;
  users: Array<RawUser> = [];
  allUsers: Array<RawUser> = [];
  searchQuery = "";
  //currentTenantId = null;

  constructor(
    private userRepository: UserRepository,
    private tenantRepository: TenantRepository,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.currentUser = this.userRepository.getCurrentUser();
    this.showPreloader = true;

    this.tenantRepository
      .getAll()
      .then((tenants) => {
        // console.log('tenants',tenants);
        tenants.map((tenant) => {
          this.tenantsByIdsDictionary[tenant.id] = tenant;
        });
      })
      .then(() => {
        this.userRepository.getUsers(null).then((users) => {
          console.log("all users", users);
          this.users = users;
          this.allUsers = users;
          this.showPreloader = false;
        });
      });
  }

  async deleteUser(userId: number) {
    const userToDelete = this.allUsers.find((u) => u.userId === userId);

    if (
      userToDelete &&
      window.confirm(
        `Are you sure you want to delete user [${userToDelete.userId.toString()}] ${userToDelete.username}`,
      )
    ) {
      await this.userRepository.delete(userId);
      this.allUsers.splice(
        this.allUsers.findIndex((u) => u.userId === userId),
        1,
      );
      this.search();
    }
  }
  goToEditUser(userId: number) {
    this.router.navigate([`users/edit/${userId}`]);
  }
  search() {
    this.users = this.allUsers.filter((user) => {
      return (
        user.email.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.firstName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.lastName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        user.username.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.tenantsByIdsDictionary[user.managedTenantIds[0]].name
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    });
  }
}
